/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AddFault.vue?vue&type=template&id=878d3468&scoped=true&"
import script from "./AddFault.vue?vue&type=script&lang=js&"
export * from "./AddFault.vue?vue&type=script&lang=js&"
import style0 from "./AddFault.vue?vue&type=style&index=0&id=878d3468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878d3468",
  null
  
)

export default component.exports